const grade_2 = {
  label: "Grade 2",
  subjects: {
     applied_design_k2: {
  label: "Applied Design (Grade 2)",
  topics: [
    // { value: "defining", label: "Defining" },
    { value: "ideating", label: "Ideating" },
    // { value: "prototyping", label: "Prototyping" },
    // { value: "testing", label: "Testing" },
    { value: "making", label: "Making" },
    { value: "sharing", label: "Sharing" },
    { value: "applied_skills", label: "Applied Skills" },
    { value: "applied_technologies", label: "Applied Technologies" }
  ],
  competencies: {
    core: [
       { value: "ideating", label: "Ideating" },
    // { value: "prototyping", label: "Prototyping" },
    // { value: "testing", label: "Testing" },
    { value: "making", label: "Making" },
    { value: "sharing", label: "Sharing" },
    { value: "applied_skills", label: "Applied Skills" },
    { value: "applied_technologies", label: "Applied Technologies" }
    ],
   sub: {
      applied_design: [
        // Defining
        {
          value: "identify_needs_opportunities",
          label: "Identify needs and opportunities for designing, through exploration"
        },

        // Ideating
        {
          value: "generate_ideas",
          label: "Generate ideas from their experiences and interests"
        },
        {
          value: "add_to_others_ideas",
          label: "Add to others’ ideas"
        },
        {
          value: "choose_idea",
          label: "Choose an idea to pursue"
        },

        // Prototyping
        {
          value: "choose_tools_materials",
          label: "Choose tools and materials"
        },
        {
          value: "make_product",
          label: "Make a product using known procedures or through modelling of others"
        },

        // Testing
        {
          value: "trial_and_error",
          label: "Use trial and error to make changes, solve problems, or incorporate new ideas from self or others"
        },

        // Making
        {
          value: "decide_sharing",
          label: "Decide on how and with whom to share their product"
        },

        // Sharing
        {
          value: "demonstrate_product",
          label: "Demonstrate their product, tell the story of designing and making their product, and explain how their product contributes to the individual, family, community, and/or environment"
        },
        {
          value: "evaluate_design_solution",
          label: "Use personal preferences to evaluate the success of their design solutions"
        },
        {
          value: "reflect_on_ability",
          label: "Reflect on their ability to work effectively both as individuals and collaboratively in a group"
        }
      ],

      applied_skills: [
        {
          value: "safe_use_tools",
          label: "Use materials, tools, and technologies in a safe manner in both physical and digital environments"
        },
        {
          value: "develop_skills_play",
          label: "Develop their skills and add new ones through play and collaborative work"
        }
      ],

      applied_technologies: [
        {
          value: "explore_simple_tools",
          label: "Explore the use of simple, available tools and technologies to extend their capabilities"
        }
      ]
    }
  }
},
  "arts_2": {
    "label": "Arts Education (Grade 2)",
    topics: [
        { value: "Expanding and Creating", label: "Expanding and Creating" },
        { value: "reasoning_reflecting", label: "Reasoning and Reflecting" },
        { value: "communicating_documenting", label: "Communicating and Documenting" },
        // { value: "connecting_expanding", label: "Connecting and Expanding" }
      ],
      competencies: {
        core: [
          { value: "Exploring", label: "Expanding and Creating" },
          { value: "Reasoning", label: "Reasoning and Reflecting" },
          { value: "Communicating", label: "Communicating and Documenting" },
          // { value: "Connecting", label: "Connecting and Expanding" }
        ],

      "sub": {
        "exploring_creating": [
          {
            "value": "explore_elements_processes",
            "label": "Explore elements, processes, materials, movements, technologies, tools, and techniques of the arts"
          },
          {
            "value": "create_artistic_works_collab_individual",
            "label": "Create artistic works collaboratively and individually using ideas inspired by imagination, inquiry, experimentation, and purposeful play"
          },
          {
            "value": "explore_personal_experience_culture",
            "label": "Explore personal experience, community, and culture through arts activities"
          }
        ],

        "reasoning_reflecting": [
          {
            "value": "observe_share_artist_use",
            "label": "Observe and share how artists (dancers, actors, musicians, and visual artists) use processes, materials, movements, technologies, tools, and techniques"
          },
          {
            "value": "develop_processes_skills_refine",
            "label": "Develop processes and technical skills in a variety of art forms to refine artistic abilities"
          },
          {
            "value": "reflect_connect_experiences",
            "label": "Reflect on creative processes and make connections to other experiences"
          }
        ],

        "communicating_documenting": [
          {
            "value": "interpret_symbolism_meaning",
            "label": "Interpret symbolism and how it can be used to express meaning through the arts"
          },
          {
            "value": "express_feelings_ideas_stories",
            "label": "Express feelings, ideas, stories, observations, and experiences through creative works"
          },
          {
            "value": "describe_respond_artworks",
            "label": "Describe and respond to works of art"
          }
        ],

        "connecting_expanding": [
          {
            "value": "experience_document_share",
            "label": "Experience, document, and share creative works in a variety of ways"
          },
          {
            "value": "demonstrate_application_content",
            "label": "Demonstrate increasingly sophisticated application and/or engagement of curricular content"
          }
        ]
      }
    }
  }
,

   career_education_2: {
      label: 'Career Education (Grade 2)',
      topics: [],
      competencies: {
        core: [
          { value: 'examine', label: 'Examine' },
          { value: 'interact', label: 'Interact' },
          { value: 'experience', label: 'Experience' },
          { value: 'initiate', label: 'Initiate' },
          { value: 'share', label: 'Share' }
        ],
        sub: {
          examine: [
            { value: 'identify_and_appreciate_personal_attributes', label: 'Identify and appreciate their personal attributes, skills, interests, and accomplishments' },
            { value: 'demonstrate_effective_work_habits', label: 'Demonstrate effective work habits and organizational skills appropriate to their level of development' }
          ],
          interact: [
            { value: 'work_respectfully_and_constructively', label: 'Work respectfully and constructively with others to achieve common goals' },
            { value: 'identify_and_appreciate_roles_and_responsibilities', label: 'Identify and appreciate the roles and responsibilities of people in their schools, families, and communities' },
            { value: 'recognize_the_importance_of_positive_relationships', label: 'Recognize the importance of positive relationships in their lives' }
          ],
          experience: [
            { value: 'recognize_the_importance_of_learning', label: 'Recognize the importance of learning in their lives and future careers' }
          ],
          initiate: [
            { value: 'set_and_achieve_realistic_learning_goals', label: 'Set and achieve realistic learning goals for themselves' }
          ],
          share: [
            { value: 'share_ideas_information_feelings_and_knowledge', label: 'Share ideas, information, personal feelings, and knowledge with others' },
            { value: 'recognize_the_basic_skills_required', label: 'Recognize the basic skills required in a variety of jobs in the community' }
          ]
        }
      }
    },
  "english_2": {
    "label": "English Language Arts (Grade 2)",
    "topics": [
      { "value": "comprehend_connect", "label": "Comprehend and Connect (Reading, Listening, Viewing)" },
      { "value": "create_communicate", "label": "Create and Communicate (Writing, Speaking, Representing)" }
    ],
    "competencies": {
      "core": [
        { "value": "comprehend_connect", "label": "Comprehend and Connect (reading, listening, viewing)" },
        { "value": "create_communicate", "label": "Create and Communicate (writing, speaking, representing)" }
      ],
      "sub": {
        "comprehend_connect": [
          {
            "value": "read_fluently_grade_level",
            "label": "Read fluently at grade level (Grade 1–3)"
          },
          {
            "value": "use_sources_prior_knowledge",
            "label": "Use sources of information and prior knowledge to make meaning (K-3)"
          },
          {
            "value": "use_read_listen_view_strategies",
            "label": "Use developmentally appropriate reading, listening, and viewing strategies to make meaning (K-3)"
          },
          {
            "value": "recognize_text_structures",
            "label": "Recognize how different text structures reflect different purposes"
          },
          {
            "value": "engage_actively",
            "label": "Engage actively as listeners, viewers, and readers to develop understanding of self, identity, and community (K-3)"
          },
          {
            "value": "awareness_story_identity",
            "label": "Demonstrate awareness of the role that story plays in personal, family, and community identity"
          },
          {
            "value": "use_personal_experience_connections",
            "label": "Use personal experience and knowledge to connect to stories and other texts to make meaning (K-2)"
          },
          {
            "value": "recognize_structure_elements_story",
            "label": "Recognize the structure and elements of story (Grade 1–3)"
          },
          {
            "value": "awareness_fp_story_connections",
            "label": "Show awareness of how story in First Peoples cultures connects people to family and community (Grade 1–3)"
          }
        ],

        "create_communicate": [
          {
            "value": "exchange_ideas_perspectives",
            "label": "Exchange ideas and perspectives to build shared understanding (K-5)"
          },
          {
            "value": "create_stories_texts_awareness",
            "label": "Create stories and other texts to deepen awareness of self, family, and community (K-3)"
          },
          {
            "value": "plan_create_variety_forms",
            "label": "Plan and create a variety of communication forms for different purposes and audiences (Grade 1–3)"
          },
          {
            "value": "communicate_using_conventions",
            "label": "Communicate using sentences and most conventions of Canadian spelling, grammar, and punctuation (Grade 2–3)"
          },
          {
            "value": "explore_oral_storytelling",
            "label": "Explore oral storytelling processes (K-2)"
          }
        ]
      }
    }
  }

,
   "math_2": {
    "label": "Mathematics (Grade 2)",
    "topics": [
      { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
      { "value": "understanding_solving", "label": "Understanding and Solving" },
      { "value": "communicating_representing", "label": "Communicating and Representing" },
      { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
    ],

    "competencies": {
      "core": [
        { "value": "reasoning_analyzing", "label": "Reasoning and Analyzing" },
        { "value": "understanding_solving", "label": "Understanding and Solving" },
        { "value": "communicating_representing", "label": "Communicating and Representing" },
        { "value": "connecting_reflecting", "label": "Connecting and Reflecting" }
      ],

      "sub": {
        "reasoning_analyzing": [
          {
            "value": "use_reasoning_make_connections_k5",
            "label": "Use reasoning to explore and make connections"
          },
          {
            "value": "estimate_reasonably_k5",
            "label": "Estimate reasonably"
          },
          {
            "value": "develop_mental_math_strategies_k5",
            "label": "Develop mental math strategies and abilities to make sense of quantities"
          },
          {
            "value": "use_technology_explore_math_k5",
            "label": "Use technology to explore mathematics"
          }
        ],

        "understanding_solving": [
          {
            "value": "model_mathematics_context_k5",
            "label": "Model mathematics in contextualized experiences"
          },
          {
            "value": "apply_understanding_play_inquiry_k5",
            "label": "Develop, demonstrate, and apply mathematical understanding through play, inquiry, and problem solving"
          },
          {
            "value": "visualize_explore_math_concepts_k5",
            "label": "Visualize to explore mathematical concepts"
          },
          {
            "value": "use_multiple_problem_solving_strategies_k5",
            "label": "Develop and use multiple strategies to engage in problem solving"
          },
          {
            "value": "connect_problem_solving_local_culture_k5",
            "label": "Engage in problem-solving experiences connected to place, story, cultural practices, and perspectives relevant to local First Peoples communities, the local community, and other cultures"
          }
        ],

        "communicating_representing": [
          {
            "value": "communicate_math_thinking_k5",
            "label": "Communicate mathematical thinking in many ways"
          },
          {
            "value": "use_math_vocabulary_k5",
            "label": "Use mathematical vocabulary and language to contribute to mathematical discussions"
          },
          {
            "value": "explain_justify_math_ideas_k5",
            "label": "Explain and justify mathematical ideas and decisions"
          },
          {
            "value": "represent_math_ideas_k5",
            "label": "Represent mathematical ideas in concrete, pictorial, and symbolic forms"
          }
        ],

        "connecting_reflecting": [
          {
            "value": "reflect_math_thinking_k5",
            "label": "Reflect on mathematical thinking"
          },
          {
            "value": "connect_math_concepts_k5",
            "label": "Connect mathematical concepts to each other and to other areas and personal interests"
          },
          {
            "value": "incorporate_first_peoples_perspectives_k5",
            "label": "Incorporate First Peoples worldviews and perspectives to make connections to mathematical concepts"
          }
        ]
      }
    }
  },
 "phe_2": {
    "label": "Physical and Health Education (Grade 2)",
   "topics": [
      { "value": "physical_literacy", "label": "Physical Literacy" },
      { "value": "healthy_active_living", "label": "Healthy and Active Living" },
      { "value": "social_community_health", "label": "Social and Community Health" },
      { "value": "mental_well_being", "label": "Mental Well-Being" }
    ],

    "competencies": {
      "core": [
        { "value": "physical_literacy", "label": "Physical Literacy" },
        { "value": "healthy_active_living", "label": "Healthy and Active Living" },
        { "value": "social_community_health", "label": "Social and Community Health" },
        { "value": "mental_well_being", "label": "Mental Well-Being" }
      ],


      "sub": {
        "physical_literacy": [
          {
            "value": "fundamental_movement_skills_2",
            "label": "Develop and demonstrate a variety of fundamental movement skills in a variety of physical activities and environments (K–2)"
          },
          {
            "value": "monitor_exertion_levels_2",
            "label": "Apply methods of monitoring exertion levels in physical activity (2–4)"
          },
          {
            "value": "safety_fair_play_leadership_2",
            "label": "Develop and demonstrate safety, fair play, and leadership in physical activities (K–9)"
          },
          {
            "value": "positive_experiences_activity_2",
            "label": "Identify and explain factors that contribute to positive experiences in physical activities (2–3)"
          }
        ],

        "healthy_active_living": [
          {
            "value": "participate_daily_activity_2",
            "label": "Participate daily in physical activity at moderate to vigorous intensity levels (K–4)"
          },
          {
            "value": "identify_opportunities_activity_2",
            "label": "Identify and describe opportunities to be physically active at school, home, and community"
          },
          {
            "value": "healthy_eating_strategies_2",
            "label": "Explore strategies for making healthy eating choices"
          },
          {
            "value": "access_health_info_2",
            "label": "Describe ways to access health information and support services (2–3)"
          },
          {
            "value": "components_healthy_living_2",
            "label": "Explore and describe components of healthy living"
          }
        ],

        "social_community_health": [
          {
            "value": "avoidance_assertiveness_unsafe_2",
            "label": "Identify and describe avoidance or assertiveness strategies in unsafe situations (2–4)"
          },
          {
            "value": "demonstrate_respectful_behaviour_2",
            "label": "Develop and demonstrate respectful behaviour (K–2)"
          },
          {
            "value": "positive_relationships_2",
            "label": "Identify and describe characteristics of positive relationships"
          },
          {
            "value": "outdoor_activities_connection_2",
            "label": "Explain how participation in outdoor activities supports connection with community and environment (2–3)"
          }
        ],

        "mental_well_being": [
          {
            "value": "strategies_promote_mental_well_being_2",
            "label": "Identify and apply strategies that promote mental well-being (2–3)"
          },
          {
            "value": "identify_feelings_worries_2",
            "label": "Identify and describe feelings, worries, and strategies for dealing with them"
          },
          {
            "value": "personal_skills_interests_self_identity_2",
            "label": "Identify personal skills, interests, and preferences and describe how they influence self-identity"
          }
        ]
      }
    }
  },

   
    
    science_2: {
      label: "Science (Grade 2)",
      topics: [
        { value: "life_cycles", label: "Life Cycles" },
        { value: "matter", label: "Properties of Matter" },
        { value: "earth_materials", label: "Earth Materials" }
      ],
      competencies: {
        core: [
          { value: "questioning_predicting", label: "Questioning and Predicting" },
          { value: "planning_conducting", label: "Planning and Conducting" },
          { value: "processing_analyzing", label: "Processing and Analyzing Data and Information" },
          { value: "evaluating", label: "Evaluating" },
          { value: "applying_innovating", label: "Applying and Innovating" },
          { value: "communicating", label: "Communicating" }
        ],
        sub: {
          questioning_predicting: [
            { value: "curiosity", label: "Demonstrate curiosity and a sense of wonder about the world" },
            { value: "observe_familiar", label: "Observe objects and events in familiar contexts" },
            { value: "ask_questions", label: "Ask questions about familiar objects and events" },
            { value: "make_predictions", label: "Make simple predictions about familiar objects and events" }
          ],
          planning_conducting: [
            { value: "make_record_observations", label: "Make and record observations" },
            { value: "safely_manipulate", label: "Safely manipulate materials to test ideas and predictions" },
            { value: "simple_measurements", label: "Make and record simple measurements using informal or non-standard methods" }
          ],
          processing_analyzing: [
            { value: "interpret_environment", label: "Experience and interpret the local environment" },
            { value: "first_peoples_knowledge", label: "Recognize First Peoples stories, songs, and art as ways to share knowledge" },
            { value: "sort_classify_data", label: "Sort and classify data and information using drawings, pictographs, and provided tables" },
            { value: "compare_with_predictions", label: "Compare observations with predictions through discussion" },
            { value: "identify_patterns", label: "Identify simple patterns and connections" },
            { value: "compare_observations", label: "Compare observations with those of others" }
          ],
          evaluating: [
            { value: "environmental_consequences", label: "Consider some environmental consequences of their actions" }
          ],
          applying_innovating: [
            { value: "caring_actions", label: "Take part in caring for self, family, classroom, and school through personal approaches" },
            { value: "apply_learning", label: "Transfer and apply learning to new situations" },
            { value: "generate_new_ideas", label: "Generate and introduce new or refined ideas when problem solving" }
          ],
          communicating: [
            { value: "communicate_observations", label: "Communicate observations and ideas using oral or written language, drawing, or role-play" },
            { value: "express_reflect", label: "Express and reflect on personal experiences of place" }
          ]
        }
      }
    },
   
 

    "social_studies_2": {
    "label": "Social Studies (Grade 2)",
     "topics": [
      { "value": "inquiry", "label": "Inquiry" },
      { "value": "significance", "label": "Significance" },
      { "value": "evidence", "label": "Evidence" },
      { "value": "continuity_change", "label": "Continuity and Change" },
      { "value": "cause_consequence", "label": "Cause and Consequence" },
      { "value": "perspective", "label": "Perspective" },
      { "value": "ethical_judgement", "label": "Ethical Judgement" }
    ],

    "competencies": {
      "core": [
        { "value": "inquiry", "label": "Inquiry" },
        { "value": "significance", "label": "Significance" },
        { "value": "evidence", "label": "Evidence" },
        { "value": "continuity_change", "label": "Continuity and Change" },
        { "value": "cause_consequence", "label": "Cause and Consequence" },
        { "value": "perspective", "label": "Perspective" },
        { "value": "ethical_judgement", "label": "Ethical Judgement" }
      ],


      "sub": {
        "inquiry": [
          {
            "value": "inquiry_process_ss2",
            "label": "Use Social Studies inquiry processes and skills to ask questions; gather, interpret, and analyze ideas; and communicate findings and decisions"
          }
        ],

        "significance": [
          {
            "value": "explain_significance_ss2",
            "label": "Explain why people, events, or places are significant to various individuals and groups"
          }
        ],

        "evidence": [
          {
            "value": "ask_infer_conclude_ss2",
            "label": "Ask questions, make inferences, and draw conclusions about the content and features of different types of sources"
          }
        ],

        "continuity_change": [
          {
            "value": "sequence_explain_change_ss2",
            "label": "Sequence objects, images, and events, or explain why some aspects change and others stay the same"
          }
        ],

        "cause_consequence": [
          {
            "value": "recognize_cause_effect_ss2",
            "label": "Recognize causes and consequences of events, decisions, or developments"
          }
        ],

        "perspective": [
          {
            "value": "explain_perspectives_ss2",
            "label": "Explain why people’s beliefs, values, worldviews, experiences, and roles give them different perspectives on people, places, issues, or events"
          }
        ],

        "ethical_judgement": [
          {
            "value": "make_value_judgments_ss2",
            "label": "Make value judgments about events, decisions, or actions, and suggest lessons that can be learned"
          }
        ]
      }
    }
  },

  
 




  }
};

export default grade_2;
